module.exports = "/cabinet/img/transport-service-photo.d0770188.svg";